import React, { useEffect, useState } from "react";
import { Modal, Input, message } from "antd";
import TenantProvider from "../../../../../../shared/provider/TenantProvider";
import { TenantDto } from "../../../../../../shared/dto/TenantDto";
import DefaultButton from "../../../../../../shared/util/DefaultButton";
import AlertModal from "../../../../../../shared/util/AntModal/AlertModal";
import { useSelection } from "../../../../../../shared/context/selection/selectionProvider";

interface DeleteTenantProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  tenant: TenantDto | null;
  fetchTenants: () => void;
}

const DeleteTenant: React.FC<DeleteTenantProps> = ({ open, setOpen, tenant, fetchTenants }) => {
  const [confirmName, setConfirmName] = useState("");
  const [showFinalWarning, setShowFinalWarning] = useState(false);
  const tenantProvider = new TenantProvider();
  const [isLoading, setLoading] = useState(false);
  const { tenantName } = useSelection();
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (!open) {
      setConfirmName("");
    }
  }, [open]);

  const handleDelete = async () => {
    if (!tenant) return;
    if (confirmName !== tenant.name) {
      message.error("O nome digitado não corresponde ao nome do tenant.");
      return;
    }

    if (tenantName === tenant.name) {
      setShowAlert(true);
      return;
    }

    setShowFinalWarning(true);
  };

  const handleFinalDelete = async () => {
    if (!tenant) return;

    setLoading(true);
    try {
      await tenantProvider.delete(tenant.tenantId);
      fetchTenants();
      setOpen(false);
      setShowFinalWarning(false);
      message.success("Tenant excluído com sucesso.");
    } catch (error) {
      message.error("Erro ao excluir tenant.");
      console.error("Erro ao excluir tenant:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        title="Excluir Tenant"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
      >
        <p>Para confirmar a exclusão, digite o nome do tenant abaixo:</p>
        <Input
          placeholder="Digite o nome do tenant"
          value={confirmName}
          onChange={(e) => setConfirmName(e.target.value)}
        />
        <footer style={{ marginTop: 20, display: "flex", justifyContent: "space-between" }}>
          <DefaultButton
            width="125px"
            height="36px"
            fontSize="1em"
            withOutBackground={true}
            params={{
              onClick: () => setOpen(false),
            }}
          >
            Cancelar
          </DefaultButton>
          <DefaultButton
            width="125px"
            height="36px"
            fontSize="1em"
            params={{
              type: "button",
              onClick: handleDelete,
              disabled: isLoading,
            }}
          >
            {isLoading ? "Excluindo..." : "Excluir"}
          </DefaultButton>
        </footer>
      </Modal>

      <Modal
        title="Aviso Importante"
        open={showFinalWarning}
        onCancel={() => setShowFinalWarning(false)}
        footer={null}
      >
        <p>
          Todos os dados relacionados a este tenant serão perdidos, sem recuperação. 
          Isto inclui usuários, categorias, ideias, desafios, relatórios, etc.
          Deseja realmente excluir este tenant?
        </p>
        <footer style={{ marginTop: 20, display: "flex", justifyContent: "space-between" }}>
          <DefaultButton
            width="125px"
            height="36px"
            fontSize="1em"
            withOutBackground={true}
            params={{
              onClick: () => setShowFinalWarning(false),
            }}
          >
            Cancelar
          </DefaultButton>
          <DefaultButton
            width="125px"
            height="36px"
            fontSize="1em"
            params={{
              type: "button",
              onClick: handleFinalDelete,
              disabled: isLoading,
            }}
          >
            {isLoading ? "Excluindo..." : "Excluir"}
          </DefaultButton>
        </footer>
      </Modal>

      <AlertModal
        title="Aviso"
        visible={showAlert}
        onCancel={() => setShowAlert(false)}
        showConfirmButton={false}
      >
        <span>Você não pode excluir o tenant no qual está logado. Por favor, troque de tenant antes de prosseguir.</span>
      </AlertModal>
    </>
  );
};

export default DeleteTenant;
